<!--suppress JSNonASCIINames -->
<template>
  <vx-card>
    <div>
      <div class="flex justify-between items-center">
        <p style="font-size: 18px; font-weight: 700">상수도 등록</p>
        <FieldWriteButtonGroup
          :useCopy="isEditable && !!fieldId"
          :useDelete="isEditable && !!fieldId"
          :useSave="isEditable"
          @onClickCopy="onClickCopy"
          @onClickExcel="onClickDownloadExcel"
          @onClickDelete="onClickDelete"
          @onClickMoveList="onClickMoveList"
          @onClickSave="onClickSave"
        />
      </div>

      <!-- 기본정보 -->
      <div class="mt-28px">
        <h5 class="mb-4"><i class="dot"></i> 기본정보</h5>
        <div class="writeGridContainer">
          <div>
            <div>관리주체</div>
            <ml-input v-model="form.management_entity" :readonly="readonly" />
          </div>
          <div>
            <div>소유자</div>
            <ml-input v-model="form.owner" :readonly="readonly" />
          </div>
          <div>
            <div>전화번호</div>
            <ml-input v-model="form.phoneNumber" :readonly="readonly" />
          </div>
          <div>
            <div>보관자</div>
            <ml-input v-model="form.custodian" :readonly="readonly" />
          </div>
          <div>
            <div>관리방법</div>
            <vs-select autocomplete v-model="form.관리방법">
              <vs-select-item text="직접관리" value="직접관리" />
              <vs-select-item text="위탁관리" value="위탁관리" />
            </vs-select>
          </div>
          <div>
            <div>소관부서</div>
            <ml-input v-model="form.소관부서" :readonly="readonly" />
          </div>
          <div>
            <div>담당주무관</div>
            <ml-input v-model="form.담당주무관" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>

    <!-- 시설물 정보 -->
    <water-supply-write-body :form="form" :category-info="categoryInfo" :readonly="readonly" />

    <!-- 관리 부서 및 업체 등록 -->
    <company-add-module
      title="관리 부서 및 업체 등록"
      :tableColumns="[
        { head: '구분', key: 'com_type' },
        { head: '부서(업체)명', key: 'com_name' },
        { head: '연락처', key: 'phone' },
      ]"
      :isSimple="true"
      :readonly="readonly"
      :useDetail="false"
      v-model="companyList"
      @remove="removeCompany"
    />

    <!-- 전경사진 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" section-title="전경사진" placeholder="전경사진" :readonly="readonly" />

    <file-upload-module v-model="fileList" class="mt-28px" :readonly="readonly" target="field" />

    <FieldWriteButtonGroup
      :useCopy="isEditable && !!fieldId"
      :useDelete="isEditable && !!fieldId"
      :useSave="isEditable"
      @onClickCopy="onClickCopy"
      @onClickExcel="onClickDownloadExcel"
      @onClickDelete="onClickDelete"
      @onClickMoveList="onClickMoveList"
      @onClickSave="onClickSave"
    />
  </vx-card>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import CompanyAddModule from "@/views/_BS/components/CompanyAddModule";
import DateSelector from "@/components/selector/DateSelector";
import DateSelectorRang from "@/components/selector/DateSelectorRang";
import SignField from "@/components/SignField.vue";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import moment from "moment";
import BridgeWriteBody from "@/views/fields/single-page/bridge/BridgeWriteBody.vue";
import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter";
import WaterSupplyWriteBody from "@/views/fields/single-page/water-supply/WaterSupplyWriteBody.vue";

import FieldWriteButtonGroup from "@/views/fields/components/FieldWriteButtonGroup.vue";

export default {
  components: {
    WaterSupplyWriteBody,
    BridgeWriteBody,
    FileUploadModule,
    CompanyAddModule,
    DateSelector,
    DateSelectorRang,
    SignField,
    PhotoUploadGridModule,
    FieldWriteButtonGroup,
  },
  data() {
    return {
      form: {
        phoneNumber: "",
        custodian: "",
        관리방법: "직접관리",
        소관부서: "",
        담당주무관: "",

        facilityNumber: "",
        managementNumber: "",
        facilityName: "",
        routeDivision: "",
        routeDetail: "",

        facility_category_id: "",

        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",

        socEvaluationTarget: "",
        address: "",
        management_entity: "",
        management_type: "",
        owner: "",
        ownerType: "",
        businessPlanApprovalDate: "",
        completionDate: "",
        defectLiabilityExpirationDate1: "",
        detailedSpecifications: "",
        safetyInspectionAndDiagnosisHistory: "",
        repairAndReinforcementHistory: "",
        accessibleVentCover: "",
        designPeriod: "",
        designer: "",
        defectLiabilityExpirationDate2: "",
        constructionPeriod: "",
        contractor: "",
        totalConstructionCost: "",
        seismicDesignTarget: "",
        seismicDesignApplication: "",
        seismicDesignStandard: "",
        seismicPerformanceEvaluation: "",
        seismicReinforcement: "",
        young21Target: "",
        auditPeriod: "",
        auditor: "",
        projectOwner: "",
        constructionName: "",
        defectLiabilityExpirationDate: "",
        constructionSupervisor: "",
        creationDate: moment().format("YYYY-MM-DD"),
        author: this.$store.state.auth.userInfo ? this.$store.state.auth.userInfo.name : "",
        signature: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
        remarks: "",

        // 상세제원
        상세제원: {
          취수시설: "0",
          취수장: "0",
          정수장: "0",
          가압장: "0",
          배수지: "0",
          수로터널: "0",
          취수댐: "0",
          수관교: "0",
          관로시설: "",
        },
        취수시설: [],
        취수장: [],
        정수장: [],
        가압장: [],
        배수지: [],
        각종밸브실: {
          총개소: "0",
          제수밸브실: "0",
          공기밸브실: "0",
          이토밸브실: "0",
          신축관실: "0",
          기타: "0",
        },
        관로시설: [],

        companyList: [],
        photoList: [],
      },

      companyList: [],
      userList: [],
      joinUsers: [],
      fileList: [],
      categoryInfo: {
        facility_category_id: 0,
        cat1: "",
        cat2: "",
        cat3: "",
        classification: "",
      },

      catLock: true,
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldId() {
      return this.$route.params.fieldId;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    isAdmin() {
      let isAdmin = false;
      const myInfo = this.$store.state.auth.userInfo;
      isAdmin = isAdmin || parseInt(myInfo.is_superuser) > 0;
      return isAdmin;
    },
    /**
     * 현재 사용자가 프로젝트 관리자인지 확인합니다.
     * 프로젝트 관리자는 사업장을 등록/수정/삭제할 수 있습니다.
     * @returns {boolean}
     */
    isProjectManager() {
      const memberInfo = this.$store.state.member.memberInfo;
      if (memberInfo) {
        if (memberInfo.is_superuser) {
          return true;
        }

        const projects = memberInfo.projects;
        if (projects && projects.length > 0) {
          for (const project of projects) {
            if (`${project.id}` === `${this.projectId}`) {
              return project.pivot.is_manager;
            }
          }
        }
      }
      return false;
    },
    /**
     * 사업장을 프로젝트 관리자만 수정할 수 있는지 확인합니다.
     * @returns {boolean}
     */
    isFieldEditByManagerOnly() {
      const projectInfo = this.$store.state.project.projectInfo;

      if (projectInfo.field_edit_by_manager_only) {
        return true;
      }

      return false;
    },
    isEditable() {
      if (this.isFieldEditByManagerOnly) {
        return this.isProjectManager;
      }
      return true;
    },
    readonly() {
      return !this.isEditable;
    },
  },
  watch: {
    async companyList() {
      await this.initMembers();
    },
  },
  async created() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
  },
  async mounted() {
    if (this.fieldId) {
      await this.loadField();
    }
  },
  methods: {
    async loadField() {
      const fieldId = this.fieldId;
      await this.$store.dispatch("project/LOAD_FIELD", { fieldId });
      const info = this.$store.state.project.fieldInfo;

      this.joinUsers = info.users;
      this.form = { ...this.form, ...info, ...JSON.parse(info.meta) };

      if (info.facility_category) {
        this.form.facility_category_id = info.facility_category.id;
        this.form.cat1 = info.facility_category.cat1;
        this.form.cat2 = info.facility_category.cat2;
        this.form.cat3 = info.facility_category.cat3;
        this.form.classification = info.facility_category.classification;

        this.categoryInfo = {
          facility_category_id: info.facility_category.id,
          cat1: info.facility_category.cat1,
          cat2: info.facility_category.cat2,
          cat3: info.facility_category.cat3,
          classification: info.facility_category.classification,
        };
      }

      if (this.form.companies && info.companies.length > 0) {
        const companies = [];
        for (const company of info.companies) {
          companies.push(company);
        }
        this.companyList = companies;

        await this.initMembers();
      }

      // 첨부파일
      this.form.fileList = info.attachments || [];
      if (this.form.fileList) {
        this.fileList = this.form.fileList;
      }

      // this.form.photoList 항목이 2개보다 적을 경우, 빈 항목을 추가한다.
      if (this.form.photoList.length < 2) {
        for (let i = this.form.photoList.length; i < 2; i++) {
          this.form.photoList.push({ id: "", url: "" });
        }
      }
    },

    async initMembers() {
      const joinUsers = this.joinUsers;
      const members = [];
      for (const company of this.companyList) {
        members.push(...(await this.loadMember(company.id)));
      }

      for (const member of members) {
        let join_project = false;
        for (const user of joinUsers) {
          if (user.id === member.id) {
            join_project = true;
            break;
          }
        }
        member.join_project = join_project;
      }

      this.userList = members;
    },

    async loadMember(company_id) {
      const page = 1;
      const perPage = 100;
      await this.$store.dispatch("company/LOAD_MEMBER_LIST", { page, perPage, company_id });
      return JSON.parse(JSON.stringify(this.$store.state.company.memberList));
    },

    removeCompany(company) {
      let i = 0;
      for (i = 0; i < this.joinUsers.length; i++) {
        const usr = this.joinUsers[i];
        if (usr.company_id === company.id) {
          this.joinUsers.splice(i, 1);
          i--;
        }
      }
    },

    customAlert(msg, title) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: title ? title : "오류가 발생했습니다",
          message: msg,
        },
      });
      window.dispatchEvent(customAlert);
    },

    onClickSave(isCopy) {
      // 필수 : facilityName,
      if (!this.form.facilityName) {
        this.customAlert("시설물명을 입력해주세요.");
        return;
      }

      const option = {
        project_id: this.projectId, // 프로젝트 ID
        field_name: this.form.facilityName, // 현장(시설물, 사업장) 이름
        contract_code: this.form.facilityNumber, // 계약번호
        address: this.form.address, // 주소
        phone: this.form.phoneNumber, // 대표번호
        be_completed_at: this.form.completionDate, // 준공일
        deposit_amount: this.form.totalConstructionCost, // 총공사비
        facility_category_id: this.form.facility_category_id, // Category
        uploads: this.fileList.map((file) => file.id), // 파일
      };

      const company_ids = [];
      for (const com of this.companyList) {
        company_ids.push(com.id);
      }
      option.company_ids = company_ids;

      if (this.fieldId) {
        const user_ids = [];
        if (this.joinUsers.length > 0) {
          for (const user of this.joinUsers) {
            user_ids.push(user.id);
          }
        }
        option.user_ids = user_ids;
      }

      if (isCopy) {
        option.meta = {
          ...this.form,
          creationDate: moment().format("YYYY-MM-DD"),
          author: this.myInfo.name,
          lastModifiedDate: moment().format("YYYY-MM-DD"),
          lastModifiedBy: this.myInfo.name,
        };
        this.$emit("copy", option);
      } else {
        // Meta
        option.meta = {
          ...this.form,
          lastModifiedDate: moment().format("YYYY-MM-DD"),
          lastModifiedBy: this.myInfo.name,
        };
        this.$emit("save", option);
      }
    },
    onClickCopy() {
      this.onClickSave(true);
    },
    onClickDelete() {
      if (!this.fieldId) return;
      this.$emit("delete", this.fieldId);
    },
    onClickMoveList() {
      this.$emit("moveList");
    },
    async onClickDownloadExcel() {
      // 엑셀 파일 가져오기
      // 파일은 public/fms/ 경로에 저장되어 있다.
      const response = await fetch("/fms/시설물관리대장_상수도.xlsx");
      const arrayBuffer = await response.arrayBuffer();

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // 첫번째 시트의 이름 가져오기
      const worksheet = workbook.worksheets[0];

      // 시트에 데이터 입력하기
      await this.applyDataToSheet(workbook, worksheet);

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      let fileName = "";
      if (this.form.facilityName) {
        if (this.form.facilityNumber) {
          fileName = `시설물관리대장_${this.form.facilityName}_${this.form.facilityNumber}`;
        } else {
          fileName = `시설물관리대장_${this.form.facilityName}`;
        }
      } else if (this.form.facilityNumber) {
        fileName = `시설물관리대장_${this.form.facilityNumber}`;
      } else {
        fileName = `시설물관리대장`;
      }
      fileName += ".xlsx";

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    },
    async applyDataToSheet(workbook, worksheet) {
      const cellMatchInfo = {
        facilityNumber: ["V4", "B20"], // 시설물번호
        managementNumber: ["V5", "I20"], // 관리번호
        facilityName: ["V6", "O20", "B41"], // 시설물명
        management_entity: ["T13", "R22"], // 관리주체
        owner: ["T14", "AO22"], // 소유자
        custodian: ["T15"], // 보관자
        routeDivision: ["Y20"], // 하천명-구분
        routeDetail: ["AD20"], // 하천명-세부노선
        cat3: ["AK20"], // 시설물종류
        classification: ["AQ20"], // 시설물종별
        cat1: ["AX20"], // 시설물구분
        socEvaluationTarget: ["BD20"], // SOC성능평가대상
        address: ["B22"], // 주소
        businessPlanApprovalDate: ["B27"], // 사업계획승인일
        completionDate: ["F27"], // 준공일
        defectLiabilityExpirationDate1: ["N27"], // 하자보수보증종료일
        detailedSpecifications: ["S27"], // 상세제원
        safetyInspectionAndDiagnosisHistory: ["X27"], // 안전점검진단이력
        repairAndReinforcementHistory: ["AF27"], // 보수보강이력
        accessibleVentCover: ["AM27"], // 환기구 덮개
        designer: ["Q29"], // 설계자
        contractor: ["AL29"], // 시공자
        totalConstructionCost: ["AZ29"], // 총공사비
        seismicDesignTarget: ["E31"], // 지진설계대상
        seismicDesignApplication: ["Q31"], // 지진설계적용
        seismicDesignStandard: ["Z31"], // 지진설계기준
        seismicPerformanceEvaluation: ["AL31"], // 지진성능평가
        seismicReinforcement: ["AZ31"], // 지진보강
        young21Target: ["B33"], // 영21조대상
        auditor: ["Q33"], // 감리자
        projectOwner: ["Z33"], // 사업주체
        constructionName: ["AL33"], // 공사명
        constructionSupervisor: ["AZ33"], // 공사감독
        creationDate: ["B36"], // 작성일
        lastModifiedDate: ["AA36"], // 최종 수정일
        lastModifiedBy: ["AR36"], // 최종 수정자
        remarks: ["D37"], // 비고

        // 상세제원
      };

      for (const key in cellMatchInfo) {
        const cell = cellMatchInfo[key];
        for (const c of cell) {
          worksheet.getCell(c).value = this.form[key] ? this.form[key] : "";
        }
      }

      worksheet.getCell("X25").value = "";
      worksheet.getCell("AB25").value = "";
      worksheet.getCell("AG25").value = "";
      worksheet.getCell("AK23").value = "";
      if (this.form.management_type === "중앙부처") {
        worksheet.getCell("X25").value = "V";
      } else if (this.form.management_type === "지자체") {
        worksheet.getCell("AB25").value = "V";
      } else if (this.form.management_type === "(국가/지방)공기업") {
        worksheet.getCell("AG25").value = "V";
      } else if (this.form.management_type === "민간") {
        worksheet.getCell("AK23").value = "V";
      }

      worksheet.getCell("AU25").value = "";
      worksheet.getCell("BA25").value = "";
      worksheet.getCell("BC25").value = "";
      worksheet.getCell("BF23").value = "";
      if (this.form.ownerType === "중앙부처") {
        worksheet.getCell("AU25").value = "V";
      } else if (this.form.ownerType === "지자체") {
        worksheet.getCell("BA25").value = "V";
      } else if (this.form.ownerType === "(국가/지방)공기업") {
        worksheet.getCell("BC25").value = "V";
      } else if (this.form.ownerType === "민간") {
        worksheet.getCell("BF23").value = "V";
      }

      // 전화번호 (AK14)
      worksheet.getCell("AJ14").value = `전화번호: ${this.form.phoneNumber}`;

      // 첨부자료 목록 (AV27)
      const fileNames = this.fileList.map((file) => file.originalName).join(", ");
      worksheet.getCell("AV27").value = fileNames;

      // 설계기간 (B29)
      worksheet.getCell("B29").value = `${this.form.designPeriod.sDate} ~ ${this.form.designPeriod.eDate}`;

      // 공사기간 (Z29)
      worksheet.getCell("Z29").value = `${this.form.constructionPeriod.sDate} ~ ${this.form.constructionPeriod.eDate}`;

      // 감리기간 (E33)
      worksheet.getCell("E33").value = `${this.form.auditPeriod.sDate} ~ ${this.form.auditPeriod.eDate}`;

      // 작성자 (L36)
      worksheet.getCell("L36").value = `${this.form.author}  (인)`;

      // 상세제원
      worksheet.getCell("P41").value = `${this.form.상세제원.취수시설} 개`;
      worksheet.getCell("S41").value = `${this.form.상세제원.취수장} 개`;
      worksheet.getCell("W41").value = `${this.form.상세제원.정수장} 개`;
      worksheet.getCell("AC41").value = `${this.form.상세제원.가압장} 개`;
      worksheet.getCell("AI41").value = `${this.form.상세제원.배수지} 개`;
      worksheet.getCell("AO41").value = `${this.form.상세제원.수로터널} 개`;
      worksheet.getCell("AS41").value = `${this.form.상세제원.취수댐} 개`;
      worksheet.getCell("AY41").value = `${this.form.상세제원.수관교} 개`;
      worksheet.getCell("BE41").value = `${this.form.상세제원.관로시설} ㎞`;

      // 코드가 길어져서 함수로 분리
      this.addExcelTable_취수시설(worksheet);
      this.addExcelTable_취수장(worksheet);
      this.addExcelTable_정수장(worksheet);
      this.addExcelTable_가압장(worksheet);
      this.addExcelTable_배수지(worksheet);
      this.addExcelTable_각종밸브실(worksheet);
      this.addExcelTable_관로시설(worksheet);

      excelSupporter.addHeader(worksheet, [{ value: "전경사진", style: "border", merge: "B:BF" }]);
      const row = worksheet.addRow([]);
      const rowIndex = row.number;
      async function blobToString(blob) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => {
            resolve(reader.result);
          };
          reader.readAsDataURL(blob);
        });
      }

      for (const photo of this.form.photoList) {
        if (photo.id) {
          const paths = photo.path.split("/");
          const hashedName = paths[paths.length - 1];
          const ext = hashedName.split(".")[1];

          await this.$store.dispatch("file/FILE_DOWNLOAD", { hashedName }).then(async (response) => {
            const imageId = await workbook.addImage({
              base64: await blobToString(response),
              extension: ext,
            });
            const _index = rowIndex + parseInt(imageId / 2);
            worksheet.addImage(imageId, {
              tl: { col: 1.2 + (imageId % 2) * 27, row: _index - 1 },
              ext: { width: 500, height: 400 },
            });
            if (imageId % 2 === 0) {
              worksheet.getRow(_index).height = 320;
              worksheet.unMergeCells(`B${_index}:AB${_index}`);
              worksheet.mergeCells(`B${_index}:AB${_index}`);
              worksheet.unMergeCells(`AC${_index}:BF${_index}`);
              worksheet.mergeCells(`AC${_index}:BF${_index}`);
            }
          });
        }
      }
    },
    addExcelTable_취수시설(worksheet) {
      const data = [];
      data.push([{ value: "취 수 시 설", colspan: 8, style: "borderHead" }]);
      if (this.form.취수시설.length === 0) {
        data.push(
          [
            { value: "명칭", style: "borderHead" },
            { value: "시설용량", style: "borderHead" },
            { value: "취수원", style: "borderHead" },
            { value: "취수형식", style: "borderHead" },
            { value: "하천수계", style: "borderHead" },
            { value: "하천명", style: "borderHead" },
            { value: "하천등급", style: "borderHead" },
            { value: "부대시설", style: "borderHead" },
          ],
          [{ value: "", rowspan: 2 }, "m³/일", "", "", "", "", "", ""],
          [undefined, { value: "주소", style: "borderHead" }, { value: "", colspan: 3, style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: "", colspan: 2, style: "borderLeft" }]
        );
      } else {
        for (const item of this.form.취수시설) {
          data.push(
            [
              { value: "명칭", style: "borderHead" },
              { value: "시설용량", style: "borderHead" },
              { value: "취수원", style: "borderHead" },
              { value: "취수형식", style: "borderHead" },
              { value: "하천수계", style: "borderHead" },
              { value: "하천명", style: "borderHead" },
              { value: "하천등급", style: "borderHead" },
              { value: "부대시설", style: "borderHead" },
            ],
            [{ value: item.명칭, rowspan: 2 }, `${item.시설용량} m³/일`, item.취수원, item.취수형식, item.하천수계, item.하천명, item.하천등급, item.부대시설],
            [undefined, { value: "주소", style: "borderHead" }, { value: item.주소, colspan: 3, style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: item.관련정수장, colspan: 2, style: "borderLeft" }]
          );
        }
      }

      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:P", "Q:T", "U:Z", "AA:AH", "AI:AO", "AP:AV", "AW:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_취수장(worksheet) {
      // 취수장: [],
      const data = [];
      data.push([{ value: "취 수 장", colspan: 5, style: "borderHead" }]);
      if (this.form.취수장.length === 0) {
        data.push(
          [
            { value: "명칭", style: "borderHead" },
            { value: "시설용량", style: "borderHead" },
            { value: "펌프사양", style: "borderHead" },
            { value: "건축물연면적", style: "borderHead" },
            { value: "부대시설", style: "borderHead" },
          ],
          [{ value: "", rowspan: 2 }, "m³/일", "", "", ""],
          [undefined, { value: "주소", style: "borderHead" }, { value: "", style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: "", style: "borderLeft" }]
        );
      }
      for (const item of this.form.취수장) {
        data.push(
          [
            { value: "명칭", style: "borderHead" },
            { value: "시설용량", style: "borderHead" },
            { value: "펌프사양", style: "borderHead" },
            { value: "건축물연면적", style: "borderHead" },
            { value: "부대시설", style: "borderHead" },
          ],
          [{ value: item.명칭, rowspan: 2 }, `${item.시설용량} m³/일`, item.펌프사양, item.건축물연면적, item.부대시설],
          [undefined, { value: "주소", style: "borderHead" }, { value: item.주소, style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: item.관련정수장, style: "borderLeft" }]
        );
      }
      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:P", "Q:AH", "AI:AO", "AP:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_정수장(worksheet) {
      // 정수장: [],
      const data = [];
      data.push([{ value: "정  수  장", colspan: 8, style: "borderHead" }]);
      if (this.form.정수장.length === 0) {
        data.push(
          [
            { value: "명칭", style: "borderHead", rowspan: 2 },
            { value: "시설용량", style: "borderHead", rowspan: 2 },
            { value: "착수정", style: "borderHead", colspan: 2 },
            { value: "혼화지", style: "borderHead", colspan: 2 },
            { value: "응접침전지", style: "borderHead", colspan: 2 },
          ],
          [
            undefined,
            undefined,
            { value: "형식", style: "borderHead" },
            { value: "개수(지)", style: "borderHead" },
            { value: "형식", style: "borderHead" },
            { value: "개수(지)", style: "borderHead" },
            { value: "형식", style: "borderHead" },
            { value: "개수(지)", style: "borderHead" },
          ],
          [{ value: "", rowspan: 5 }, "m³/일", "", "", "", "", "", ""],
          [
            undefined,
            { value: "여과지", style: "borderHead", colspan: 2 },
            { value: "정수지", style: "borderHead", colspan: 2 },
            { value: "고도처리시설", style: "borderHead", rowspan: 2 },
            { value: "배출수처리시설", style: "borderHead", rowspan: 2 },
            { value: "건축물연면적", style: "borderHead", rowspan: 2 },
          ],
          [undefined, { value: "형식", style: "borderHead" }, { value: "개수(지)", style: "borderHead" }, { value: "형식", style: "borderHead" }, { value: "개수(지)", style: "borderHead" }],
          [undefined, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }],
          [undefined, { value: "주소", style: "borderHead" }, { value: "", style: "borderLeft", colspan: 3 }, { value: "관련정수장", style: "borderHead" }, { value: "", style: "borderLeft", colspan: 2 }]
        );
      } else {
        for (const item of this.form.정수장) {
          data.push(
            [
              { value: "명칭", style: "borderHead", rowspan: 2 },
              { value: "시설용량", style: "borderHead", rowspan: 2 },
              { value: "착수정", style: "borderHead", colspan: 2 },
              { value: "혼화지", style: "borderHead", colspan: 2 },
              { value: "응접침전지", style: "borderHead", colspan: 2 },
            ],
            [
              undefined,
              undefined,
              { value: "형식", style: "borderHead" },
              { value: "개수(지)", style: "borderHead" },
              { value: "형식", style: "borderHead" },
              { value: "개수(지)", style: "borderHead" },
              { value: "형식", style: "borderHead" },
              { value: "개수(지)", style: "borderHead" },
            ],
            [{ value: item.명칭, rowspan: 5 }, `${item.시설용량} m³/일`, item.착수정_형식, item.착수정_개수, item.혼화지_형식, item.혼화지_개수, item.응접침전지_형식, item.응접침전지_개수],
            [
              undefined,
              { value: "여과지", style: "borderHead", colspan: 2 },
              { value: "정수지", style: "borderHead", colspan: 2 },
              { value: "고도처리시설", style: "borderHead", rowspan: 2 },
              { value: "배출수처리시설", style: "borderHead", rowspan: 2 },
              { value: "건축물연면적", style: "borderHead", rowspan: 2 },
            ],
            [undefined, { value: "형식", style: "borderHead" }, { value: "개수(지)", style: "borderHead" }, { value: "형식", style: "borderHead" }, { value: "개수(지)", style: "borderHead" }],
            [undefined, { value: item.여과지_형식 }, { value: item.여과지_개수 }, { value: item.정수지_형식 }, { value: item.정수지_개수 }, { value: item.고도처리시설 }, { value: item.배출수처리시설 }, { value: item.건축물연면적 }],
            [undefined, { value: "주소", style: "borderHead" }, { value: item.주소, style: "borderLeft", colspan: 3 }, { value: "관련정수장", style: "borderHead" }, { value: item.관련정수장, style: "borderLeft", colspan: 2 }]
          );
        }
      }
      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:Q", "R:V", "W:AD", "AE:AM", "AN:AS", "AT:BD", "BE:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_가압장(worksheet) {
      // 가압장: [],
      const data = [];
      data.push([{ value: "가 압 장", colspan: 5, style: "borderHead" }]);
      if (this.form.가압장.length === 0) {
        data.push(
          [
            { value: "명칭", style: "borderHead" },
            { value: "시설용량", style: "borderHead" },
            { value: "펌프사양", style: "borderHead" },
            { value: "건축물연면적", style: "borderHead" },
            { value: "부대시설", style: "borderHead" },
          ],
          [{ value: "", rowspan: 2 }, "m³/일", "", "", ""],
          [undefined, { value: "주소", style: "borderHead" }, { value: "", style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: "", style: "borderLeft" }]
        );
      } else {
        for (const item of this.form.가압장) {
          data.push(
            [
              { value: "명칭", style: "borderHead" },
              { value: "시설용량", style: "borderHead" },
              { value: "펌프사양", style: "borderHead" },
              { value: "건축물연면적", style: "borderHead" },
              { value: "부대시설", style: "borderHead" },
            ],
            [{ value: item.명칭, rowspan: 2 }, `${item.시설용량} m³/일`, item.펌프사양, item.건축물연면적, item.부대시설],
            [undefined, { value: "주소", style: "borderHead" }, { value: item.주소, style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: item.관련정수장, style: "borderLeft" }]
          );
        }
      }
      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:P", "Q:AH", "AI:AO", "AP:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_배수지(worksheet) {
      // 배수지: [],
      const data = [];
      data.push([{ value: "조절지 및 배  수  지", colspan: 5, style: "borderHead" }]);
      if (this.form.배수지.length === 0) {
        data.push(
          [
            { value: "명칭", style: "borderHead" },
            { value: "시설용적", style: "borderHead" },
            { value: "개수(지)", style: "borderHead" },
            { value: "건축물연면적", style: "borderHead" },
            { value: "부대시설", style: "borderHead" },
          ],
          [{ value: "", rowspan: 2 }, "m³/일", "", "", ""],
          [undefined, { value: "주소", style: "borderHead" }, { value: "", style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: "", style: "borderLeft" }]
        );
      } else {
        for (const item of this.form.배수지) {
          data.push(
            [
              { value: "명칭", style: "borderHead" },
              { value: "시설용적", style: "borderHead" },
              { value: "개수(지)", style: "borderHead" },
              { value: "건축물연면적", style: "borderHead" },
              { value: "부대시설", style: "borderHead" },
            ],
            [{ value: item.명칭, rowspan: 2 }, `${item.시설용적} m³/일`, item.개수, item.건축물연면적, item.부대시설],
            [undefined, { value: "주소", style: "borderHead" }, { value: item.주소, style: "borderLeft" }, { value: "관련정수장", style: "borderHead" }, { value: item.관련정수장, style: "borderLeft" }]
          );
        }
      }
      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:P", "Q:AH", "AI:AO", "AP:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_각종밸브실(worksheet) {
      const data = [];
      data.push([{ value: "각종 밸브실", colspan: 6, style: "borderHead" }]);
      data.push([
        { value: "총 개소", style: "borderHead" },
        { value: "제수밸브실", style: "borderHead" },
        { value: "공기밸브실", style: "borderHead" },
        { value: "이토밸브실", style: "borderHead" },
        { value: "신축관실", style: "borderHead" },
        { value: "기타", style: "borderHead" },
      ]);
      data.push([
        `${this.form.각종밸브실.총개소 || 0} 개소`,
        `${this.form.각종밸브실.제수밸브실 || 0} 개소`,
        `${this.form.각종밸브실.공기밸브실 || 0} 개소`,
        `${this.form.각종밸브실.이토밸브실 || 0} 개소`,
        `${this.form.각종밸브실.신축관실 || 0} 개소`,
        `${this.form.각종밸브실.기타 || 0} 개소`,
      ]);

      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:R", "S:AA", "AB:AK", "AL:AV", "AW:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
    addExcelTable_관로시설(worksheet) {
      const data = [];
      data.push([{ value: "관 로 시 설", colspan: 7, style: "borderHead" }]);

      if (this.form.관로시설.length === 0) {
        data.push([
          { value: "계통명칭", style: "borderHead" },
          { value: "관로구분", style: "borderHead" },
          { value: "관종", style: "borderHead" },
          { value: "관경", style: "borderHead" },
          { value: "구간(Station No.)", style: "borderHead" },
          { value: "연장", style: "borderHead" },
          { value: "방식설비종류", style: "borderHead" },
        ]);
        data.push([{ value: "", rowspan: 2 }, "", "", "mm", "", "㎞", ""]);
        data.push([undefined, { value: "주소", style: "borderHead" }, { value: "", style: "borderLeft", colspan: 2 }, { value: "관련정수장", style: "borderHead", colspan: 2 }, { value: "", style: "borderLeft" }]);
      } else {
        for (const item of this.form.관로시설) {
          data.push([
            { value: "계통명칭", style: "borderHead" },
            { value: "관로구분", style: "borderHead" },
            { value: "관종", style: "borderHead" },
            { value: "관경", style: "borderHead" },
            { value: "구간(Station No.)", style: "borderHead" },
            { value: "연장", style: "borderHead" },
            { value: "방식설비종류", style: "borderHead" },
          ]);
          data.push([{ value: item.계통명칭, rowspan: 2 }, item.관로구분, item.관종, `${item.관경} mm`, item.구간, `${item.연장} ㎞`, item.방식설비종류]);
          data.push([undefined, { value: "주소", style: "borderHead" }, { value: item.주소, style: "borderLeft", colspan: 2 }, { value: "관련정수장", style: "borderHead", colspan: 2 }, { value: item.관련정수장, style: "borderLeft" }]);
        }
      }

      excelSupporter.addTable(worksheet, {
        rowHeight: 22.4,
        colgroup: ["B:I", "J:P", "Q:Y", "Z:AG", "AH:AS", "AT:BA", "BB:BF"],
        data,
      });
      excelSupporter.addEmpty(worksheet, 1);
    },
  },
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 5px;
  }

  th {
    background: #f9f9f9;
    padding: 10px 4px;
  }
}
</style>
<style scoped lang="scss">
.table-list {
  .action-button {
    margin-left: auto;
  }
}

.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}

.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.size-search {
  width: 200px;
}

.input-se {
  width: 100%;

  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }

  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }

  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }

  &::v-deep .inline-block {
    width: 100% !important;
  }
}

.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}

.search-item {
  width: 100% !important;
  margin: 0 !important;

  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }

  &::v-deep > div:last-child {
    flex: 1 !important;

    .con-select {
      width: 100%;
    }
  }
}

.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0;
  display: inline-block;

  .vx-card__body {
    padding: 0 !important;
  }
}

span.up {
  color: #28c76f;
}

span.down {
  color: #ea5455;
}

.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
